import ConfigurablePane from './_configurable-pane.js'
import FlexPane from './_flex-pane.js'
import PayableInfo from './_payable-info.js'
import EarlyPayoutIndicator from './_early-payout-indicator.js'
import FreebetStakeInfo from './_freebet-stake-info.js'
import CashStakeInfo from './_cash-stake-info.js'
import PrewagerStakeInfo from './_prewager-stake-info.js'
import StakeTaxInfo from './_stake-tax-info.js'
import StakeInfo from './_stake-info.js'
import TotalPayoutInfo from './_total-payout-info.js'
import PayoutInfo from './_payout-info.js'
import Text from './_text.js'
import BetStatusIcon from './_bet-status-icon.js'
import Hideable from './_hideable.js'
import DownloadBetPdfButton from './_download-bet-pdf-button.js'
import ScrollPane from './_scroll-pane.js'
import Button from './_button.js'
import Image from './_image.js'
import ChangedValueIndicator from './_changed-value-indicator.js'
import DateTime from './_date-time.js'
import BetBonusPromotions from './_bet-bonus-promotions.js'
import MatchAccaSelectionItem from './_match-acca-selection-item.js'
import FormattedLabelWithTotalOdds from './_formatted-label-with-total-odds.js'
import OddsBoostNotification from './_odds-boost-notification.js'

export default {
  name: 'BetHistoryDetails',
  values: {
    showCompactLayout: true,
    _desktop_showCompactLayout: false,
    style: {
      headerScrolled: {
        padding: '0 0 4px 8px',
        $mixin: [
          {
            configSet: ConfigurablePane,
          },
        ],
      },
    },
    betFundsContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    totalPayable: {
      configSet: PayableInfo,
      configValues: {},
    },
    earlyPayoutIndicator: {
      configSet: EarlyPayoutIndicator,
      configValues: {
        popover: {
          button: {
            style: {
              base: {
                minHeight: '16px',
              },
            },
          },
        },
      },
    },
    freebetStake: {
      configSet: FreebetStakeInfo,
      configValues: {},
    },
    cashStake: {
      configSet: CashStakeInfo,
      configValues: {},
    },
    prewager: {
      configSet: PrewagerStakeInfo,
      configValues: {},
    },
    stakeTax: {
      configSet: StakeTaxInfo,
      configValues: {},
    },
    primaryTotalStake: {
      configSet: StakeInfo,
      configValues: {},
    },
    secondaryTotalStake: {
      configSet: StakeInfo,
      configValues: {},
    },
    totalPayoutInfo: {
      configSet: TotalPayoutInfo,
      configValues: {},
    },
    oddsBoostInfo: {
      configSet: PayoutInfo,
      configValues: {},
    },
    content: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          padding: '0 0 16px 0',
          _desktop_maxHeight: '590px',
          _desktop_width: '432px',
        },
      },
    },
    header: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '8px',
          _desktop_flexGrow: 0,
          _desktop_padding: '0 0 4px 8px',
        },
      },
    },
    betTypeContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexDirection: 'column',
          justifyContent: 'center',
          _desktop_padding: '0 8px 8px 0',
        },
      },
    },
    betTypeText: {
      configSet: Text,
      configValues: {},
    },
    betStatusContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexGrow: 0,
          justifyContent: 'flex-end',
          alignItems: 'flex-start',
        },
      },
    },
    betStatusText: {
      configSet: Text,
      configValues: {
        style: {
          textTransform: 'uppercase',
        },
      },
    },
    betInfo: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          padding: '4px 8px',
          _desktop_flexGrow: 0,
        },
        itemSpacing: '2px',
      },
    },
    betHeaderInfoContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '2px',
      },
    },
    betLabel: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
      },
    },
    receiptLabel: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
      },
    },
    deviceIdLabel: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
      },
    },
    legs: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexDirection: 'column',
          padding: '8px 8px 8px 16px',
          _desktop_flexGrow: 0,
        },
      },
    },
    detailsLabel: {
      configSet: Text,
      configValues: {
        container: {
          padding: '8px 8px 0',
        },
      },
    },
    legStatusIcon: {
      configSet: BetStatusIcon,
      configValues: {
        open: {
          style: {
            minWidth: '12px',
            minHeight: '17px',
          },
        },
        lost: {
          style: {
            minWidth: '12px',
            minHeight: '17px',
          },
        },
        void: {
          style: {
            minWidth: '12px',
            minHeight: '17px',
          },
        },
        won: {
          style: {
            minWidth: '12px',
            minHeight: '17px',
          },
        },
        cashedOut: {
          style: {
            minWidth: '12px',
            minHeight: '17px',
          },
        },
      },
    },
    betStatusIcon: {
      configSet: BetStatusIcon,
      configValues: {
        open: {
          style: {
            minWidth: '16px',
            minHeight: '16px',
          },
        },
        lost: {
          style: {
            minWidth: '16px',
            minHeight: '16px',
          },
        },
        void: {
          style: {
            minWidth: '16px',
            minHeight: '16px',
          },
        },
        won: {
          style: {
            minWidth: '16px',
            minHeight: '16px',
          },
        },
        cashedOut: {
          style: {
            minWidth: '16px',
            minHeight: '16px',
          },
        },
      },
    },
    legInfo: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexDirection: 'column',
          padding: '0 0 8px 0',
          _desktop_flexGrow: 0,
        },
      },
    },
    selectionContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
      },
    },
    selectionNameContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          alignItems: 'center',
        },
      },
    },
    selectionName: {
      configSet: Text,
      configValues: {},
    },
    oddsLabel: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
      },
    },
    marketName: {
      configSet: Text,
      configValues: {
        container: {
          padding: '0 0 0 20px',
        },
      },
    },
    eventName: {
      configSet: Text,
      configValues: {
        container: {
          padding: '0 0 0 20px',
        },
      },
    },
    eventStartDateTime: {
      configSet: Hideable,
      configValues: {
        hide: true,
      },
    },
    eventStartDateTimeText: {
      configSet: Text,
      configValues: {
        container: {
          padding: '0 0 0 20px',
        },
      },
    },
    matchAcca: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          padding: '0 0 16px 0',
        },
      },
    },
    matchAccaHeaderText: {
      configSet: Text,
      configValues: {},
    },
    matchAccaEventName: {
      configSet: Text,
      configValues: {
        container: {
          padding: '0 0 8px 20px',
        },
      },
    },
    matchAccaLeg: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '0 16px',
          alignItems: 'center',
        },
      },
    },
    matchAccaSelectionName: {
      configSet: Text,
      configValues: {
        container: {
          padding: '0 0 0 4px',
        },
      },
    },
    receiptInfo: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '2px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    receiptTextInfo: {
      configSet: FlexPane,
      configValues: {},
    },
    channelLabel: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
      },
    },
    channelValue: {
      configSet: Text,
      configValues: {
        container: {
          padding: '0 0 0 4px',
        },
      },
    },
    receiptNumber: {
      configSet: Text,
      configValues: {
        container: {
          padding: '0 0 0 4px',
        },
      },
    },
    deviceIdNumber: {
      configSet: Text,
      configValues: {
        container: {
          padding: '0 0 0 4px',
        },
      },
    },
    hidePdfButton: false,
    pdfButtonContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          padding: '8px',
          justifyContent: 'center',
          _desktop_flexGrow: 0,
        },
      },
    },
    downloadBetPdfButton: {
      configSet: DownloadBetPdfButton,
      configValues: {
        style: {
          text: {
            paddingLeft: '8px',
          },
        },
        button: {
          style: {
            base: {
              flexGrow: 0,
              justifyContent: 'center',
            },
          },
        },
        text: {
          hide: false,
        },
      },
    },
    errorContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '8px',
          justifyContent: 'center',
          _desktop_flexGrow: 0,
        },
      },
    },
    errorLabel: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
      },
    },
    betInfoContent: {
      configSet: ScrollPane,
      configValues: {
        direction: 'y',
      },
    },
    closeButton: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            flexGrow: 0,
            padding: '2px 0 0 8px',
          },
        },
      },
    },
    closeIcon: {
      configSet: Image,
      configValues: {
        src: 'cancel-thin',
        style: {
          minWidth: '12px',
          minHeight: '12px',
        },
      },
    },
    bestOddsIcon: {
      configSet: Image,
      configValues: {
        src: 'racing-bestodds',
        style: {
          minWidth: '16px',
          minHeight: '16px',
        },
      },
    },
    priceBoostIndicator: {
      configSet: ChangedValueIndicator,
      configValues: {
        container: {
          style: {
            alignItems: 'center',
          },
        },
        indicationIcon: {
          src: 'double-arrow-right',
          style: {
            minWidth: '12px',
            minHeight: '12px',
          },
        },
      },
    },
    priceInfoContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexGrow: 0,
          alignItems: 'center',
        },
      },
    },
    betPlacementDateTimeFormat: {
      configSet: DateTime,
      configValues: {
        format: 'NUMERIC_DATE_TIME',
      },
    },
    eventNameTimeFormat: {
      configSet: DateTime,
      configValues: {
        format: 'SHORT_TIME',
      },
    },
    eventStartDateTimeFormat: {
      configSet: DateTime,
      configValues: {},
    },
    betBonusPromotions: {
      configSet: BetBonusPromotions,
      configValues: {
        container: {
          style: {
            padding: '8px 0',
          },
        },
      },
    },
    settleBetInfoContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '2px',
      },
    },
    settleBetLabel: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
      },
    },
    settleBetValue: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
      },
    },
    settledDateTimeFormat: {
      configSet: DateTime,
      configValues: {
        format: 'NUMERIC_DATE_TIME',
      },
    },
    legDateTimeFormat: {
      configSet: DateTime,
      configValues: {},
    },
    legDateTimeContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          padding: '8px 0 0 16px',
        },
      },
    },
    legDateInfoText: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
      },
    },
    matchAccaSelectionItem: {
      configSet: MatchAccaSelectionItem,
      configValues: {
        selectionContainer: {
          style: {
            padding: '0 0 0 20px',
          },
        },
      },
    },
    totalOdds: {
      configSet: FormattedLabelWithTotalOdds,
      configValues: {},
    },
    notificationContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          padding: '0 0 0 20px',
        },
      },
    },
    oddsBoostNotification: {
      configSet: OddsBoostNotification,
      configValues: {},
    },
    matchAccaOddsBoostNotification: {
      configSet: OddsBoostNotification,
      configValues: {
        container: {
          style: {
            padding: '8px 0 4px 20px',
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
